// 📁 src/utils/auditarICV.js
import MATRIZ from './matrizCorrecaoICV';

// respostas: array[87] com 'A'|'B'|'C'
export function auditarICV(respostas) {
  const get = (q) => (respostas[q - 1] || '').toUpperCase();
  const out = {};
  for (const fator of Object.keys(MATRIZ)) {
    const itens = MATRIZ[fator];
    let score = 0;
    const ok = [];
    const fail = [];
    for (const [q, alt] of itens) {
      const r = get(q);
      if (r === alt) { score++; ok.push(q); }
      else fail.push({ q, esperado: alt, marcado: r || '(vazio)' });
    }
    out[fator] = { score, total: itens.length, ok, fail };
  }
  // compostos (R/A) com base nos brutos
  const brutos = (f) => out[f].score;
  out.R = { score: brutos('I')+brutos('II')+brutos('III')+brutos('IV') };
  out.A = { score: brutos('V')+brutos('VI')+brutos('VII')+brutos('VIII') };
  return out;
}
